import React from 'react';
import PropTypes from 'prop-types';
import { ComponentLoader } from '../../../global/ComponentLoader/ComponentLoader';

const importFunc = () => {
    return import(/* webpackChunkName: "PdpSharedReturnModalWrapper" */
    './PdpSharedReturnModalWrapper').then(
        ({ PdpSharedReturnModalWrapper }) => PdpSharedReturnModalWrapper
    );
};

function PdpSharedReturnModalLoader(props) {
    return <ComponentLoader {...props} load={props.isOpen} importFunc={importFunc} />;
}

PdpSharedReturnModalLoader.propTypes = {
    itemId: PropTypes.string.isRequired,
    userId: PropTypes.string,
    environment: PropTypes.object.isRequired,

    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { PdpSharedReturnModalLoader };
